'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isSupport;

function isSupport(property) {
  return property.substr(0, 9) === '@supports';
}